import ArcGauge from '../ui/ArcGauge.jsx'

export default function ParticipantStatsGrid({ participants, onSelect }) {
  if (!participants?.length) {
    return (
      <div className="flex items-center justify-center h-40">
        <div className="flex flex-col items-center gap-3 bg-gray-800 rounded-2xl p-8 text-white/70">
          <span className="text-4xl">👥</span>
          <p className="text-sm">Aucun joueur à afficher.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
      {participants.map(p => {
        const k = p.kart
        const hasAnswers = k.total > 0
        const taux = hasAnswers ? Math.round(k.correctes / k.total * 100) : null
        const tauxColor = taux === null ? '' : taux >= 75 ? 'text-green-400' : taux >= 50 ? 'text-amber-400' : 'text-red-400'
        return (
          <button
            key={k.id}
            onClick={() => onSelect(p)}
            className="bg-gray-800 border border-white/10 rounded-2xl p-3 flex flex-col items-center gap-2 hover:border-white/30 transition-colors text-center"
          >
            <span className="text-white/40 text-xs font-medium self-start">#{k.rang}</span>
            <span className="text-3xl leading-none">{k.type_vehicule}</span>
            <p className="text-white text-xs font-semibold truncate w-full">{k.pseudo}</p>
            {hasAnswers ? (
              <>
                <ArcGauge
                  correctes={k.correctes} timeouts={k.timeouts}
                  incorrectes={k.incorrectes} total={k.total} size={90}
                />
                <p className={`text-xs font-semibold ${tauxColor}`}>{taux}%</p>
              </>
            ) : (
              <p className="text-white/30 text-xs py-2">Aucune réponse</p>
            )}
          </button>
        )
      })}
    </div>
  )
}
